import { FC, useEffect, useRef, useState } from 'react';
import { Card, Box, Grid, Stack, Typography, Modal } from '@mui/material';
import Container from '@mui/material/Container';
import "../../index.css"
import { Link as RouterLink } from 'react-router-dom';
import SigninForm from './SigninForm';
import HomeHeader from './HomeHeader';
// import loginImage from '../.././login-image.png';

import BgImg0 from './images/bg-registration-form-2.jpg';
import BgImg from './images/header/banner-bg.svg';
import BgImg2 from './images/bg2.png';
import Img0 from './images/icon.png';
import Img1 from './images/wareozo-light.png';
import Img01 from './images/wareozo.png';
import Img2 from './images/header/header-hero.png';
import Img3 from './images/brands/uideck.svg';
import Img4 from './images/brands/ayroui.svg';
import Img5 from './images/brands/graygrids.svg';
import Img6 from './images/brands/lineicons.svg';
import Img7 from './images/brands/ecommerce-html.svg';
import Img8 from './images/services/services-shape.svg';
import Img9 from './images/services/services-shape-1.svg';
import Img10 from './images/services/services-shape-2.svg';
import Img11 from './images/services/services-shape-3.svg';
import Img12 from './images/about/about1.svg';
import Img13 from './images/about/about-shape-1.svg';
import Img14 from './images/about/about-shape-2.svg';
import Img15 from './images/about/about2.svg';
import Img16 from './images/about/about3.svg';
import Img17 from './images/video/video.png';
import Img18 from './images/video/dots.svg';
// import { Helmet } from "react-helmet";
import SignUpForm from '../SignUp/SignUpForm';
import ForgotPassword from '../ForgotPassword/ForgotPassword';


/**
 * Sign In form Component. 
 */
// export function AddLibrary(urlOfTheLibrary:string) {
//   const script = document.createElement("script");
//   script.src = urlOfTheLibrary;
//   script.async = true;
//   document.body.appendChild(script);
// }



const PrivacyPolicy: FC = () => {

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const [type, setType] = useState('0');

  const navRef = useRef<any>()

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  
  useEffect(() => {
    import('./css/animate.css');
    import('./css/glightbox.min.css');
    import('./css/lineicons.css');
    import('./css/bootstrap.min.css');
    import('./css/style.css');
    import('./css2/style.css');
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const { offsetTop } = navRef.current
      if (window.pageYOffset > offsetTop) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const isMobile = width <= 768;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1200);
  }, [])
  return (
    <>

      {loading && <div className="preloader">
        <div className="loader">
          <div className="spinner">
            <div className="spinner-container">
              <div className="spinner-rotator">
                <div className="spinner-left">
                  <div className="spinner-circle"></div>
                </div>
                <div className="spinner-right">
                  <div className="spinner-circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}

      <header className="header-area" style={{marginTop: '-64px'}}>
        <div ref={navRef} className={`navbar-area ${scrolled && 'sticky'}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav className="navbar navbar-expand-lg">
                  <a className="navbar-brand" href="/signin">
                    <img src={Img0} alt="Logo" style={{ width: isMobile ? scrolled ? 40 : 60 : scrolled ? 50 : 80 }} />
                    <img src={scrolled ? Img01 : Img1} alt="Logo" style={{ width: isMobile ? scrolled ? 80 : 120 : scrolled ? 120 : 150 }} />
                  </a>
                  <button
                    className={`navbar-toggler ${menu && 'active'}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => setMenu(!menu)}
                  >
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                  </button>

                  <div
                    className={`collapse navbar-collapse sub-menu-bar ${menu && 'show'}`}
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#home">Home</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#features">Features</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#pricing">Pricing</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#about">About</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#facts">Why</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a href="/signin#faq">FAQ</a>
                      </li>
                    </ul>
                  </div>

                  <div className="navbar-btn d-none d-sm-inline-block">
                    <a
                      className="main-btn"
                      style={{ backgroundColor: scrolled ? '#059669' : '#fff', color: scrolled ? '#fff' : '#059669', border: '2px solid #059669', textDecoration: 'none' }}
                      data-scroll-nav="0"
                      onClick={() => setOpen(!open)}
                      // href="https://uideck.com/templates/basic/"
                      rel="nofollow"
                    >
                      Login Now
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div
          id="home"
          className="header-hero bg_cover"
          style={{ backgroundImage: `url(${BgImg})` }}

        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="header-hero-content text-center">
                  {/* <h3
                    className="header-sub-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.2s"
                  >
                    Basic - SaaS Landing Page
                  </h3> */}
                  <h2
                    className="header-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.5s"
                  >
                    Privacy & Policy
                  </h2>
                  {/* <p
                    className="text wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.8s"
                  >
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor
                  </p>
                  <a
                    href="javascript:void(0)"
                    onClick={() => setOpen(!open)}
                    className="main-btn wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="1.1s"
                  >
                    Get Started
                  </a> */}
                </div>
              </div>
            </div>
            <div style={{ height: 300 }}>

            </div>
          </div>
          <div id="particles-1" className="particles"></div>
        </div>

      </header>

      <section>
        <div style={{padding: '0 10%'}}>

          <h2 style={{marginTop: '20px', marginBottom: '10px'}}>Introduction</h2>
          <p>
            Welcome to Wareozo ("we," "our," "us"). This Privacy Policy explains how we collect, use, and protect your personal data when using our billing application, including our integration with Meta's WhatsApp Business API to send messages.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Information We Collect</h2>
          <p>
            We may collect the following information when users interact with us via WhatsApp:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Name</li>
            <li>Mobile number</li>
            <li>WhatsApp profile name and profile picture (if available)</li>
            <li>Message content sent via WhatsApp</li>
            <li>Appointment details, enquiry details, and transaction information</li>
          </ul>
          <p>
            This information is collected through the official WhatsApp Business Platform APIs.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>How We Use the Information</h2>
          <p>
            We use WhatsApp communication data for:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Appointment booking and confirmation</li>
            <li>Service updates and reminders</li>
            <li>Customer support</li>
            <li>Marketing campaigns (only with user consent)</li>
            <li>Transactional notifications</li>
          </ul>
          <p>
            We do not sell or rent your personal data to third parties.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Consent for WhatsApp Communication</h2>
          <p>
            By contacting us via WhatsApp or submitting your phone number through our website, you consent to receive:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Transactional messages</li>
            <li>Service updates</li>
            <li>Promotional messages (if opted-in)</li>
          </ul>
          <p>
            Users may opt out at any time by replying "STOP" or contacting our support team.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Data Storage and Security</h2>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>All data is securely stored in our CRM system.</li>
            <li>We use encrypted connections while communicating with WhatsApp APIs.</li>
            <li>Access to personal data is restricted to authorized personnel only.</li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Third-Party Sharing</h2>
          <p>
            We may share limited information with:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Official WhatsApp Business API provider</li>
            <li>Cloud hosting providers</li>
            <li>Payment gateway providers (if applicable)</li>
          </ul>
          <p>
            All third parties comply with applicable data protection laws.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Data Retention</h2>
          <p>
            We retain WhatsApp communication data only as long as necessary for:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Legal compliance</li>
            <li>Service fulfillment</li>
            <li>Business operations</li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>User Rights</h2>
          <p>
            Users may request:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Access to their personal data</li>
            <li>Correction of inaccurate data</li>
            <li>Deletion of their data</li>
          </ul>
          <p>
            Requests can be sent to: wareozo.alerts@gmail.com
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Platform Usage Disclosure</h2>
          <p>
            Our business uses the official WhatsApp Business Platform APIs to communicate with customers for service, support, and notification purposes.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Changes to This Policy</h2>
          <p>
            We may update this policy periodically. Users will be notified of significant changes.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px'}}>Contact Information</h2>
          <p>
            For questions, reach out to wareozo.alerts@gmail.com.
          </p>

        </div>
      </section>

      <footer id="footer" className="footer-area pt-120">
        <div className="container">
          <div
            className="subscribe-area wow fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
          >
            <div className="row">
              <div className="col-lg-6">
                <div className="subscribe-content mt-45">
                  <h2 className="subscribe-title">
                    Subscribe Our Newsletter <span>get reguler updates</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="subscribe-form mt-50">
                  <form action="#">
                    <input type="text" placeholder="Enter email" />
                    <button className="main-btn">Subscribe</button>
                  </form>
                </div>
              </div>
            </div>

          </div>
          <div className="footer-widget pb-100">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-8">
                <div
                  className="footer-about mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.2s"
                >
                  <a className="logo" href="javascript:void(0)">
                    <img src={Img0} alt="Wareozo" style={{ width: 80 }} />
                    <img src={Img1} alt="Wareozo" />
                  </a>
                  <p className="text">
                    Simplify invoicing, automate accounting, and boost business growth with smart, secure, and efficient wareozo billing software. 
                  </p>
                  <ul className="social">
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-facebook-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-twitter-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-instagram-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-linkedin-original"> </i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5 col-md-7 col-sm-12">
                <div className="footer-link d-flex mt-50 justify-content-sm-between">
                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.4s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Quick Link</h4>
                    </div>
                    <ul className="link">
                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                      <li><a href="/terms-of-use">Terms of Service</a></li>
                      <li><a href="/signin#pricing">Pricing</a></li>
                      <li><a href="/signin#faq">FAQ</a></li>
                    </ul>
                  </div>

                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.6s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Resources</h4>
                    </div>
                    <ul className="link">
                      <li><a href="/signin#home">Home</a></li>
                      <li><a href="/signin#features">Features</a></li>
                      <li><a href="/signin#about">About</a></li>
                      <li><a href="/signin#why">Why</a></li>
                    </ul>
                  </div>

                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12">
                <div
                  className="footer-contact mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.8s"
                >
                  <div className="footer-title">
                    <h4 className="title">Contact Us</h4>
                  </div>
                  <ul className="contact">
                    <li>wareozo.alerts@gmail.com</li>
                    <li>www.wareozo.com</li>
                    <li>
                      121, Sai Nagar, Near HBL Tower, <br /> Nagpur, Maharashtra - 441108 
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright d-sm-flex justify-content-between">
                  <div className="copyright-content">
                    <p className="text">
                      Designed and Developed by 
                      <a href="javascript:void(0)" rel="nofollow"> &nbsp; Wareozo</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div id="particles-2"></div>
      </footer>

      <a href="#" className="back-to-top"> <i className="lni lni-chevron-up"> </i> </a>

      <Modal open={open} onClose={(event: any, reason: any) => {
        if (reason && reason == "backdropClick" && "escapeKeyDown")
          setOpen(false);
      }}>
        <div className='centerme'>
          <div className={`${isMobile ? 'maindiv2' : 'maindiv'}`}>
            <div style={{ width: isMobile ? '100%' : '50%' }}>
              {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType} /> : <ForgotPassword setType={setType} />}
            </div>
            {!isMobile && <div style={{ width: '50%' }}>
              <img src={BgImg2} />
            </div>}
          </div>

          {/* <div style={{backgroundImage: `url(${BgImg0})`, padding: 20,paddingTop:40, paddingBottom:40, width:'100%', height:'auto',margin:'auto',display:'flex',flexDirection:'row'}}>
            {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType}/> : <ForgotPassword setType={setType}/>}
            </div> */}

        </div>
      </Modal>

      {/* <Helmet>
      <script src="js/bootstrap.bundle.min.js" type="text/javascript"></script>
    <script src="js/wow.min.js" type="text/javascript"></script>
    <script src="js/glightbox.min.js" type="text/javascript"></script>
    <script src="js/count-up.min.js" type="text/javascript"></script>
    <script src="js/particles.min.js" type="text/javascript"></script>
    <script src="js/main.js" type="text/javascript"></script>
      </Helmet> */}

      {/* {AddLibrary("./js/bootstrap.bundle.min.js")}
      {AddLibrary("./js/wow.min.js")}
      {AddLibrary("./js/glightbox.min.js")}
      {AddLibrary("./js/count-up.min.js")}
      {AddLibrary("./js/particles.min.js")}
      {AddLibrary("./js/main.js")} */}
    </>
  );
}

export default PrivacyPolicy;

